module.exports = __webpack_public_path__ + "img/mikayla-zeitlin.9593a3cb.jpg";